import { Link } from 'react-router-dom';
import { SITE } from '../../config/site';
import { SEO_PAGES } from '../../config/seo';
import { Breadcrumbs } from '../../components/ui/Breadcrumbs';
import { Seo } from '../../components/seo';
import { buildBreadcrumbJsonLd } from '../../seo/buildBreadcrumbJsonLd';
import { buildLocalBusinessJsonLd } from '../../seo/buildLocalBusinessJsonLd';
import styles from './DeliveryPage.module.css';

export function DeliveryPage() {
  const seo = SEO_PAGES.delivery;

  return (
    <div className={`container ${styles.page}`}>
      <Seo
        title={seo.title}
        description={seo.description}
        path={seo.path}
        jsonLd={[
          buildLocalBusinessJsonLd(),
          buildBreadcrumbJsonLd([
            { label: 'Главная', to: '/' },
            { label: 'Доставка', to: '/delivery' },
          ]),
        ]}
      />

      <Breadcrumbs
        items={[
          { label: 'Главная', to: '/' },
          { label: 'Доставка' },
        ]}
      />

      <h1 className={styles.title}>Доставка</h1>

      <div className={styles.body}>
        <div className={styles.content}>
          <p>
            Оперативная доставка по {SITE.city}у — в течение 2 часов после подтверждения заказа.
          </p>
          <p>
            Чтобы оформить доставку, напишите нам в мессенджер MAX по телефону магазина{' '}
            <a href={`tel:${SITE.phone.replace(/\D/g, '')}`}>{SITE.phone}</a> — укажите товары
            и количество.
          </p>
          <p>
            После расчёта стоимости доставки и оплаты вызовем курьера Яндекс Go. Заказы
            обрабатываем в рабочее время: {SITE.hours.toLowerCase()}.
          </p>


          <Link to="/catalog" className={styles.catalogLink}>
            Перейти в каталог
          </Link>
        </div>

       
      </div>
    </div>
  );
}
